<template>
  <v-flex
    xs12
    md10
    offset-md1
    align-self-center
    justify-center
  >
    <v-row>
        <v-col
          cols="8"
        >
          <v-col
          cols="3"
        >
          <v-select
            :items="propagandists"
            item-text="fullname"
            item-value="id"
            v-model="filters.propagandistId"
            :label="$t('fields.propagandist')"
            :error-messages="errors"
            clearable
          >
          </v-select>
        </v-col>
        </v-col>
    </v-row>
    <v-card flat light>
      <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="totalItems"
        :no-data-text="$t('NO_DATA')"
        :no-results-text="$t('NO_DATA')"
        hide-default-footer
        :options.sync="pagination"
        :loading="loading"
        class="elevation-1"
      >

        <template v-slot:[`item.is_primary`]="{ item }">
           <v-icon v-if="item.schools.options && item.schools.options.is_primary">
            done
           </v-icon>
           <v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.is_suggested`]="{ item }">
           <v-icon v-if="item.adoptions.is_suggested">
            done
           </v-icon>
           <v-icon v-else>cancel</v-icon>
        </template>


        <template v-slot:[`item.is_new`]="{ item }">
           <v-icon v-if="item.adoptions.is_new">
            done
           </v-icon>
           <v-icon v-else>cancel</v-icon>
        </template>

        <template v-slot:[`item.is_secondary`]="{ item }">
            <v-icon v-if="item.schools.options && item.schools.options.is_secondary">
              done
            </v-icon>
            <v-icon v-else>cancel</v-icon>
        </template>

      </v-data-table>
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        @change="fetchReport"
      />
    </v-card>
  </v-flex>
</template>
<script>

import { adoptionsService } from '../../../utils/services/adoptions.service';
import { propagandistsService } from '../../../utils/services/propagandists.service';
import Paginator from '../../../components/shared/Paginator';

export default {
  name: 'AdoptionReportPropagandistEditor',
  components: { Paginator },

  data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        propagandists: [],
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['editor'],
        },
        headers: [
          { text: this.$t('fields.editor'), value: 'editor' },
          { text: this.$t('fields.propagandist'), value: 'propagandist' },
          { text: this.$t('fields.section'), value: 'adoptions.counter_section' },
          { text: this.$t('fields.is_new'), value: 'adoptions.counter_new' },
          { text: this.$t('fields.capociclo'), value: 'adoptions.counter_capociclo' },
        ],
        filters: {
          propagandistId: null,
        },
      };
    },

    computed: {
      requestFilters() {
        const filters = {
          propagandistId: this.filters.propagandistId,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },

    methods: {

      async fetchPropagandist() {
        return propagandistsService.index()
        .then(response => {
            this.propagandists = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchReport(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return adoptionsService.reportPropagandistEditor({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        },
          )
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
              this.handleError(error, this.errors);
          }).finally(() => {
            this.loading = false;
          });
      },
    },
    async created() {
      this.fetchPropagandist();
      this.fetchReport(1);
    },
    watch: {
      'filters.propagandistId': {
        handler() {
          this.fetchReport(1);
        },
      },
    },
};
</script>
